import { FC, useState } from 'react';
import cx from 'clsx';

import styles from './styles.module.css';
import { useLongPress } from 'src/hooks';
import BeatLoader from 'react-spinners/BeatLoader';

type Props = {
  onClick: () => void;
  src: string;
};

export const MediaGridImage: FC<Props> = ({ onClick, src }) => {
  const [isMediaLoaded, setIsMediaLoaded] = useState(false);

  const { isPressed, touchHandlers } = useLongPress();

  const handleMediaLoaded = () => setIsMediaLoaded(true);

  return (
    <>
      {!isMediaLoaded && (
        <div className={styles.mediaLoader}>
          <BeatLoader color="white" loading={true} />
        </div>
      )}

      <img
        className={cx(styles.media, {
          [styles.mediaFullScreen]: isPressed,
        })}
        src={src}
        onLoad={handleMediaLoaded}
        onClick={onClick}
        {...touchHandlers}
      />
    </>
  );
};
